// removed by extract-text-webpack-plugin
module.exports = {"provider_progressbar":"provider_progressbar","provider_progressbar_header":"provider_progressbar_header","dark":"dark","ant-progress-inner":"ant-progress-inner"};


//////////////////
// WEBPACK FOOTER
// ./src/view/screens/Project/components/ProviderProgressBar/style.scss
// module id = 1325
// module chunks = 0